/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EventOrganizationStatus } from './EventOrganizationStatus';
import {
    EventOrganizationStatusFromJSON,
    EventOrganizationStatusFromJSONTyped,
    EventOrganizationStatusToJSON,
    EventOrganizationStatusToJSONTyped,
} from './EventOrganizationStatus';

/**
 * Schema for reading an event-organization row.
 * @export
 * @interface EventOrganizationRead
 */
export interface EventOrganizationRead {
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationRead
     */
    event_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationRead
     */
    organization_id: string;
    /**
     * 
     * @type {EventOrganizationStatus}
     * @memberof EventOrganizationRead
     */
    status?: EventOrganizationStatus;
    /**
     * 
     * @type {Date}
     * @memberof EventOrganizationRead
     */
    started_at?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationRead
     */
    invited_by?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EventOrganizationRead
     */
    created_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationRead
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EventOrganizationRead
     */
    organization_name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof EventOrganizationRead
     */
    deadline?: Date | null;
}



/**
 * Check if a given object implements the EventOrganizationRead interface.
 */
export function instanceOfEventOrganizationRead(value: object): value is EventOrganizationRead {
    if (!('event_id' in value) || value['event_id'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function EventOrganizationReadFromJSON(json: any): EventOrganizationRead {
    return EventOrganizationReadFromJSONTyped(json, false);
}

export function EventOrganizationReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventOrganizationRead {
    if (json == null) {
        return json;
    }
    return {
        
        'event_id': json['event_id'],
        'organization_id': json['organization_id'],
        'status': json['status'] == null ? undefined : EventOrganizationStatusFromJSON(json['status']),
        'started_at': json['started_at'] == null ? undefined : (new Date(json['started_at'])),
        'invited_by': json['invited_by'] == null ? undefined : json['invited_by'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'id': json['id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'deadline': json['deadline'] == null ? undefined : (new Date(json['deadline'])),
    };
}

export function EventOrganizationReadToJSON(json: any): EventOrganizationRead {
    return EventOrganizationReadToJSONTyped(json, false);
}

export function EventOrganizationReadToJSONTyped(value?: EventOrganizationRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'event_id': value['event_id'],
        'organization_id': value['organization_id'],
        'status': EventOrganizationStatusToJSON(value['status']),
        'started_at': value['started_at'] == null ? undefined : ((value['started_at'] as any).toISOString()),
        'invited_by': value['invited_by'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'id': value['id'],
        'organization_name': value['organization_name'],
        'deadline': value['deadline'] == null ? undefined : ((value['deadline'] as any).toISOString()),
    };
}

